
// Get asset URL from a card's checkbox value or img src
const bpGetUrl = (btn) => {
  const card = btn.closest('.bp__asset-card');
  return card?.querySelector('.bp__select-asset')?.value
      || card?.querySelector('img')?.src
      || '';
};

const bpToast = (msg = 'Copied!') => {
  const t = document.getElementById('bp-toast');
  if (!t) return;
  t.innerText = msg;
  t.classList.add('show');
  setTimeout(() => { t.classList.remove('show'); t.innerText = 'Copied!'; }, 1500);
};

// ASSET — COPY LINK
window.bpCopyLink = (btn) => {
  const url = bpGetUrl(btn);
  if (!url) return alert('No image');
  const card  = btn.closest('.bp__asset-card');
  const toast = card?.querySelector('.bp__copy-toast');
  navigator.clipboard.writeText(url).then(() => {
    const prev = btn.innerHTML;
    btn.innerHTML = '✓';
    setTimeout(() => btn.innerHTML = prev, 1000);
    if (toast) {
      toast.classList.add('show');
      setTimeout(() => toast.classList.remove('show'), 1200);
    }
  }).catch(() => alert('Copy failed'));
};

// ASSET — DOWNLOAD SINGLE
window.bpDownload = async (btn) => {
  const url = bpGetUrl(btn);
  if (!url) return;
  try {
    const blob = await fetch(url).then(r => r.blob());
    const a    = document.createElement('a');
    a.href     = URL.createObjectURL(blob);
    a.download = url.split('/').pop().split('?')[0] || 'image.png';
    a.click();
    URL.revokeObjectURL(a.href);
  } catch {
    const a = document.createElement('a');
    a.href     = url;
    a.download = '';
    a.click();
  }
};

// ASSET — LIGHTBOX
window.bpExpand = (btn) => {
  const img = btn.closest('.bp__asset-card')?.querySelector('img');
  if (!img) return;
  document.getElementById('bp-lightbox-img').src = img.src;
  document.getElementById('bp-lightbox').classList.add('show');
};
window.bpCloseLightbox = () =>
  document.getElementById('bp-lightbox')?.classList.remove('show');
// SHARE
function bpNativeShare() {
  const shareUrl = window.location.href;
  if (navigator.share) {
    navigator.share({ title: document.title, text: 'Check this out!', url: shareUrl })
      .catch(err => console.log('Share failed', err));
  } else {
    navigator.clipboard.writeText(shareUrl)
      .then(() => alert('Link copied!'))
      .catch(() => window.open(shareUrl, '_blank'));
  }
}

// COLORS — COPY VALUE
window.bpCopy = (btn, value) => {
  navigator.clipboard.writeText(value).then(() => {
    const prev = btn.innerHTML;
    btn.innerHTML = 'Copied ✓';
    setTimeout(() => btn.innerHTML = prev, 1200);
    bpToast('Copied!');
  }).catch(() => alert('Copy failed'));
};

// DOM READY — all init in one listener
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.bp__select-asset').forEach(input => {
    input.addEventListener('change', () =>
      input.closest('.bp__asset-card')?.classList.toggle('active', input.checked)
    );
  });
  const fontDlBtn = document.getElementById('bp-download-all-btn');
  if (fontDlBtn) {
    fontDlBtn.addEventListener('click', (e) => {
      e.preventDefault();
      (window.__fontUrls__ || []).forEach((url, i) => {
        setTimeout(() => {
          const a = Object.assign(document.createElement('a'), { href: url, download: '' });
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }, i * 300);
      });
    });
  }
  document.querySelectorAll('.bp__download-all').forEach(btn => {
    btn.addEventListener('click', async () => {

      const selected = [...document.querySelectorAll('.bp__select-asset:checked')];

      const targets = selected.length
        ? selected.map(i => i.closest('.bp__asset-card'))
        : [...document.querySelectorAll('.bp__asset-card')];

      if (!targets.length) return alert('No assets found');

      // 👉 SINGLE DOWNLOAD
      if (targets.length === 1) {
        const url = targets[0].querySelector('.bp__select-asset')?.value
                || targets[0].querySelector('img')?.src;

        if (!url) return;

        try {
          const blob = await fetch(url).then(r => r.blob());
          const a = Object.assign(document.createElement('a'), {
            href: URL.createObjectURL(blob),
            download: url.split('/').pop().split('?')[0] || 'image.png'
          });
          a.click();
          URL.revokeObjectURL(a.href);
        } catch {
          window.open(url, '_blank');
        }
        return;
      }

      // 👉 MULTIPLE DOWNLOAD (ZIP)
      const zip = new JSZip();
      let count = 0;

      for (let i = 0; i < targets.length; i++) {
        const card = targets[i];

        const url = card.querySelector('.bp__select-asset')?.value
                || card.querySelector('img')?.src;

        if (!url) continue;

        try {
          const blob = await fetch(url).then(r => r.blob());
          const fileName = url.split('/').pop().split('?')[0] || `image-${i + 1}.png`;

          zip.file(fileName, blob);
          count++;
        } catch {
          console.warn('Failed to fetch:', url);
        }
      }

      if (!count) return alert('No files to download');

      const content = await zip.generateAsync({ type: 'blob' });

      const a = Object.assign(document.createElement('a'), {
        href: URL.createObjectURL(content),
        download: 'brand-assets.zip'
      });

      a.click();
      URL.revokeObjectURL(a.href);
    });
  });


// 👉 IMAGE CLICK → TOGGLE CHECKBOX
document.querySelectorAll('.bp__asset-preview img').forEach(img => {
  img.addEventListener('click', () => {

    const card = img.closest('.bp__asset-card');
    const checkbox = card?.querySelector('.bp__select-asset');

    if (!checkbox || !card) return;

    // toggle checkbox
    checkbox.checked = !checkbox.checked;

    // toggle UI class
    card.classList.toggle('selected', checkbox.checked);

    // trigger change (optional if you use elsewhere)
    checkbox.dispatchEvent(new Event('change'));
  });
});


// 👉 KEEP UI IN SYNC WHEN CHECKBOX CLICKED DIRECTLY
document.querySelectorAll('.bp__select-asset').forEach(checkbox => {
  checkbox.addEventListener('change', () => {
    const card = checkbox.closest('.bp__asset-card');
    if (!card) return;

    card.classList.toggle('selected', checkbox.checked);
  });
});
});


  // Cache for collapsed heights, keyed by sectionId
var bpCachedHeights = {};

// Measure collapsed height: full first paragraph + gap + 2 lines of second paragraph
function bpMeasureCollapsedHeight(textEl) {
  var lineHeight = parseInt(window.getComputedStyle(textEl).lineHeight) || 24;
  var paragraphs = textEl.querySelectorAll('p');
  if (paragraphs.length < 2) return 160;
  var firstP  = paragraphs[0];
  var secondP = paragraphs[1];
  var firstPBottom = firstP.offsetTop + firstP.offsetHeight;
  var gap = secondP.offsetTop - firstPBottom;
  return firstPBottom + gap + (lineHeight * 2);
}

window.bpToggleAbout = function(sectionId) {
  var textEl = document.getElementById('bp-about-text-' + sectionId);
  var wrapEl = document.getElementById('bp-about-wrap-' + sectionId);
  var btnEl  = document.getElementById('bp-about-btn-'  + sectionId);

  if (!textEl || !btnEl) return;

  var isExpanded = btnEl.getAttribute('aria-expanded') === 'true';

  if (isExpanded) {
    // Collapse — use cached height (measured before expand, so layout is accurate)
    var collapsedH = bpCachedHeights[sectionId] || 168;
    textEl.style.setProperty('max-height', collapsedH + 'px', 'important');
    textEl.classList.remove('bp__about-text--expanded');
    textEl.classList.add('bp__about-text--collapsed');
    if (wrapEl) wrapEl.classList.remove('bp__about-text-wrap--expanded');
    btnEl.setAttribute('aria-expanded', 'false');
    btnEl.textContent = 'Read more...';
  } else {
    // Re-cache height NOW (while still collapsed = correct layout measurement)
    bpCachedHeights[sectionId] = bpMeasureCollapsedHeight(textEl);

    // Expand
    textEl.style.setProperty('max-height', '3000px', 'important');
    textEl.classList.remove('bp__about-text--collapsed');
    textEl.classList.add('bp__about-text--expanded');
    if (wrapEl) wrapEl.classList.add('bp__about-text-wrap--expanded');
    btnEl.setAttribute('aria-expanded', 'true');
    btnEl.textContent = 'Read less';
  }
};

// Init: measure and apply collapsed height to all sections on page load
function bpInitAbout() {
  document.querySelectorAll('.bp__about-text.bp__about-text--collapsed').forEach(function(el) {
    var sectionId = el.id.replace('bp-about-text-', '');
    var h = bpMeasureCollapsedHeight(el);
    bpCachedHeights[sectionId] = h;
    el.style.setProperty('max-height', h + 'px', 'important');
  });
}

// Run on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bpInitAbout);
} else {
  bpInitAbout();
}

// Re-measure on resize (collapsed sections only)
window.addEventListener('resize', function() {
  document.querySelectorAll('.bp__about-text.bp__about-text--collapsed').forEach(function(el) {
    var sectionId = el.id.replace('bp-about-text-', '');
    var h = bpMeasureCollapsedHeight(el);
    bpCachedHeights[sectionId] = h;
    el.style.setProperty('max-height', h + 'px', 'important');
  });
});


